module.exports = __webpack_public_path__ + "img/en.b89156ed.png";